import axios from "axios";
import useSWR from "swr";
import { constants } from "@cinch-nx/data-search";
var fetcher = function(url) {
    return axios.get(url).then(function(res) {
        return res.data;
    });
};
export var useVehicleCount = function() {
    var URL = "".concat(constants.VEHICLE_SEARCH_URL);
    var data = useSWR(URL, fetcher).data;
    var vehicleCount = data === null || data === void 0 ? void 0 : data.searchResultsCount;
    return {
        vehicleCount: vehicleCount
    };
};
